import { useClient } from '@composables/use-clients';
import {
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CloseSkillTreeArgsType = PostRequestArgsType<any> & {
  skillTreeCode: string;
};

export const apiCloseSkillTree = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  errorConfig = {},
  callbacks = {},
}: CloseSkillTreeArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.skillTreeClose({ domain, skillTreeCode }),
      payload: {},
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
